import React from "react";
import { Card } from "../../ui/Card";
import PropTypes from "prop-types";

const CardsDashboard = ({ data, loading }) => {
  const CARDS_DATA = [
    {
      title: "Total SMS",
      icon: "sms",
      text: "text-blue-600",
      value: data?.i_send ?? 0,
    },
    {
      title: "Inválidos",
      icon: "report_problem",
      text: "text-red-600",
      value: data?.i_invalid ?? 0,
    },
    {
      title: "Por procesar",
      icon: "pending_actions",
      text: "text-yellow-600",
      value: data?.i_pending ?? 0,
    },
    // {
    //   title: "Errores",
    //   icon: "error",
    //   text: "text-orange-600",
    //   value: data?.i_errors ?? 0,
    // },
  ];

  return (
    <>
      {CARDS_DATA.map((card, index) => (
        <Card
          key={index}
          title={card.title}
          icon={card.icon}
          text={card.text}
          loading={loading}
          value={Number(card.value)}
        />
      ))}
    </>
  );
};

CardsDashboard.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default CardsDashboard;
